import { Persona } from '@/shared/model/persona/persona.model';
import { CatalogoGenerico } from '@/shared/model/seguimiento/catalogo-generico.model';
import { PeriodoBeca } from '@/shared/model/seguimiento/periodo-beca.model';
import { Solucion } from '@/shared/model/seguimiento/solucion.model';

export interface IBecarioActividadRetribucion {
  becaId?: string | null;
  numeroApoyo?: string | null;
  becario?: Persona | null;
  periodoBeca?: PeriodoBeca | null;
  solucionSolicitud?: Solucion | null;
  responsable?: boolean;
}

export class BecarioActividadRetribucion implements IBecarioActividadRetribucion {
  constructor(
    public becaId?: string | null,
    public numeroApoyo?: string | null,
    public becario?: Persona | null,
    public periodoBeca?: PeriodoBeca | null,
    public solucionSolicitud?: Solucion | null,
    public responsable?: boolean
  ) {}

  static fromObject(data: IBecarioActividadRetribucion): BecarioActividadRetribucion {
    const sede = new BecarioActividadRetribucion();
    for (const [key, value] of Object.entries(data)) {
      sede[key] = value;
    }
    return sede;
  }
  static fromArray(data: Array<IBecarioActividadRetribucion>): Array<BecarioActividadRetribucion> {
    return data.map(item => BecarioActividadRetribucion.fromObject(item));
  }
}

export interface IActividadRetribucion {
  nombreActividad?: string;
  fechaRealizacion?: Date;
  fechaInicio?: Date;
  fechaTermino?: Date;
  modalidad?: CatalogoGenerico;
  localidad?: CatalogoGenerico;
  municipio?: CatalogoGenerico;
  estado?: CatalogoGenerico;
  region?: CatalogoGenerico;
  categoria?: CatalogoGenerico;
  subCategoria?: CatalogoGenerico;
  problemaAtendido?: string;
  objetivoActividad?: string;
  descripcionAcciones?: string;
}

export class ActividadRetribucion implements IActividadRetribucion {
  constructor(
    public nombreActividad?: string,
    public fechaRealizacion?: Date,
    public fechaInicio?: Date,
    public fechaTermino?: Date,
    public modalidad?: CatalogoGenerico,
    public localidad?: CatalogoGenerico,
    public municipio?: CatalogoGenerico,
    public estado?: CatalogoGenerico,
    public region?: CatalogoGenerico,
    public categoria?: CatalogoGenerico,
    public subCategoria?: CatalogoGenerico,
    public problemaAtendido?: string,
    public objetivoActividad?: string,
    public descripcionAcciones?: string
  ) {}

  static fromObject(data: IActividadRetribucion): ActividadRetribucion {
    const item = new ActividadRetribucion();
    for (const [key, value] of Object.entries(data)) {
      item[key] = value;
    }
    return item;
  }
}

export interface IPoblacionRetribucion {
  poblacionesBeneficiarias?: Array<CatalogoGenerico>;
  personasBeneficiadas?: number;
  mujeresBeneficiadas?: number;
  hombresBeneficiados?: number;
  otrosBeneficiados?: number;
  caracteristicasPoblacionBeneficiada?: string;
}

export class PoblacionRetribucion implements IPoblacionRetribucion {
  constructor(
    public poblacionesBeneficiarias?: Array<CatalogoGenerico>,
    public personasBeneficiadas?: number,
    public mujeresBeneficiadas?: number,
    public hombresBeneficiados?: number,
    public otrosBeneficiados?: number,
    public caracteristicasPoblacionBeneficiada?: string
  ) {}

  static fromObject(data: IPoblacionRetribucion): PoblacionRetribucion {
    const item = new PoblacionRetribucion();
    for (const [key, value] of Object.entries(data)) {
      item[key] = value;
    }
    return item;
  }
}

export interface IResultadosRetribucion {
  productosGenerados?: Array<CatalogoGenerico>;
  otroProducto?: string;
  cantidad?: number;
  resultadosAlcanzados?: string;
  evidenciasDisponibles?: Array<CatalogoGenerico>;
  otraEvidencia?: string;
}

export class ResultadosRetribucion implements IResultadosRetribucion {
  constructor(
    public productosGenerados?: Array<CatalogoGenerico>,
    public otroProducto?: string,
    public cantidad?: number,
    public resultadosAlcanzados?: string,
    public evidenciasDisponibles?: Array<CatalogoGenerico>,
    public otraEvidencia?: string
  ) {}

  static fromObject(data: IResultadosRetribucion): ResultadosRetribucion {
    const sede = new ResultadosRetribucion();
    for (const [key, value] of Object.entries(data)) {
      sede[key] = value;
    }
    return sede;
  }
}

export interface IIndicadoresRetribucion {
  numeroActividades?: number;
  horasDedicadas?: number;
  institucionesParticipantes?: number;
  comunidadesAtendidas?: number;
  impactoPercibido?: string;
  contribuciones?: Array<CatalogoGenerico>;
  otraContribucion?: string;
  resultadosObservables?: string;
  puedeReplicarse?: CatalogoGenerico;
  puedeReplicarseDesc?: string;
}

export class IndicadoresRetribucion implements IIndicadoresRetribucion {
  constructor(
    public numeroActividades?: number,
    public horasDedicadas?: number,
    public institucionesParticipantes?: number,
    public comunidadesAtendidas?: number,
    public impactoPercibido?: string,
    public contribuciones?: Array<CatalogoGenerico>,
    public otraContribucion?: string,
    public resultadosObservables?: string,
    public puedeReplicarse?: CatalogoGenerico,
    public puedeReplicarseDesc?: string
  ) {}

  static fromObject(data: IIndicadoresRetribucion): IndicadoresRetribucion {
    const sede = new IndicadoresRetribucion();
    for (const [key, value] of Object.entries(data)) {
      sede[key] = value;
    }
    return sede;
  }
}

export interface IVinculacionRetribucion {
  areaConocimiento?: CatalogoGenerico;
  temasPrioritarios?: Array<CatalogoGenerico>;
  otroTemaPrioritario?: string;
}

export class VinculacionRetribucion implements IVinculacionRetribucion {
  constructor(
    public areaConocimiento?: CatalogoGenerico,
    public temasPrioritarios?: Array<CatalogoGenerico>,
    public otroTemaPrioritario?: string
  ) {}

  static fromObject(data: IVinculacionRetribucion): VinculacionRetribucion {
    const sede = new VinculacionRetribucion();
    for (const [key, value] of Object.entries(data)) {
      sede[key] = value;
    }
    return sede;
  }
}

export interface ITestimonioRetribucion {
  aprendizaje?: string;
}

export class TestimonioRetribucion implements ITestimonioRetribucion {
  constructor(public aprendizaje?: string) {}

  static fromObject(data: ITestimonioRetribucion): TestimonioRetribucion {
    const item = new TestimonioRetribucion();
    for (const [key, value] of Object.entries(data)) {
      item[key] = value;
    }
    return item;
  }
}

export interface IMenuGenerico {
  text: string | null | undefined;
  value: CatalogoGenerico | null | undefined;
}

export class MenuGenerico implements IMenuGenerico {
  constructor(public text: string | null | undefined, public value: CatalogoGenerico | null | undefined) {}
}
